import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Zap, FileClock } from "lucide-react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";

export default function AdminAutomations() {
  const qc = useQueryClient();
  const { data: automations = [] } = useQuery({ queryKey: ["admin-automations"], queryFn: async () => (await api.get("/admin/automations")).data });
  const { data: logs = [] } = useQuery({ queryKey: ["admin-automation-logs"], queryFn: async () => (await api.get("/admin/automations/logs")).data });

  const toggle = async (a, enabled) => {
    await api.put(`/admin/automations/${a.id}`, { enabled });
    toast.success(`${a.name} ${enabled ? "enabled" : "disabled"}`);
    qc.invalidateQueries({ queryKey: ["admin-automations"] });
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Automation</h1>
      <p className="text-sm text-muted-foreground">Configurable, logged, retry-safe workflows.</p>

      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <div className="space-y-3">
          {automations.map((a) => (
            <div key={a.id} className="flex items-center justify-between bs-card p-4" data-testid={`automation-${a.id}`}>
              <div className="flex items-start gap-3">
                <div className="rounded-lg bg-primary/12 p-2 text-primary"><Zap className="h-4 w-4" /></div>
                <div><p className="font-semibold">{a.name}</p><p className="text-xs text-muted-foreground font-mono">{a.trigger} → {a.action}</p></div>
              </div>
              <Switch checked={a.enabled} onCheckedChange={(v) => toggle(a, v)} data-testid={`automation-toggle-${a.id}`} />
            </div>
          ))}
        </div>

        <div className="bs-card p-5">
          <h2 className="flex items-center gap-2 font-display font-bold"><FileClock className="h-4 w-4 text-accent" /> Automation log</h2>
          <div className="mt-3 max-h-96 space-y-2 overflow-y-auto">
            {logs.map((l) => (
              <div key={l.id} className="rounded-lg border border-border p-2.5 text-xs">
                <p className="font-medium">{l.name}</p>
                <p className="text-muted-foreground">{new Date(l.created_at).toLocaleString()}</p>
              </div>
            ))}
            {logs.length === 0 && <p className="text-sm text-muted-foreground">No automation runs yet. Submit a lead to see logs appear.</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
